import type { NotificationAssignInterventionCardProps } from "./notification-assign-intervention-card.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { BatchPreviewAssignLink } from "@/modules/batch-preview/batch-preview-assign-link";
import ModelIcon from "@/modules/model-icon";
import { ModelLink } from "@/modules/model-link";
import { NotificationCard } from "@/modules/notification/notification-card";
import { useNotificationsPanel } from "@/modules/notifications/notifications-panel";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";

const { Paragraph } = Typography;

export const NotificationAssignInterventionCard = ({
  notification,
}: NotificationAssignInterventionCardProps) => {
  const { t } = useTranslation();
  const { closePanel } = useNotificationsPanel();

  const { type, data } = notification;
  const { context, interventions, user } = data;
  const color = "var(--app-color-info)";
  const count = interventions.length;
  const ids = interventions.map(({ id }) => id);

  return (
    <NotificationCard
      notification={notification}
      icon={<ModelIcon model="intervention" style={{ color }} />}
      title={t("notification:interventionAssign.title", { count })}
      color={color}
      subTitle={user.name}
      content={
        <Paragraph ellipsis={{ rows: 2 }}>
          {t("notification:interventionAssign.description", {
            userName: user.name,
            interventionName: interventions[0]?.name ?? "",
            count,
          })}
        </Paragraph>
      }
      actions={
        <>
          {count === 1 ? (
            <ModelLink
              model="intervention"
              item={interventions[0]}
              showIcon="external"
              modelAsName
              customContext={context}
              onClick={closePanel}
            />
          ) : (
            <BatchPreviewAssignLink
              type={type}
              userName={user.name}
              ids={ids}
              customContext={context}
              onClick={closePanel}
              icon="external"
            />
          )}
          <OrganizationContextLabel context={context} isSmall />
        </>
      }
    />
  );
};
